// extracted by mini-css-extract-plugin
export var downArrow = "_90-0";
export var infoTooltipIcon = "_90-3";
export var label = "_90-1";
export var optionCard = "_90-4";
export var upArrow = "_90-2";